(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xpressive-order-fields"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (!root || root.dataset.xtReady === 'true') return;
      root.dataset.xtReady = 'true';
      const form = root.closest('form');
      if (!form) return;
      const method = root.querySelector('[data-xt-method]');
      const artwork = root.querySelector('[data-xt-artwork]');
      const fileError = root.querySelector('[data-xt-file-error]');
      const summaryMethod = root.querySelector('[data-xt-summary-method]');
      const summaryOptions = root.querySelector('[data-xt-summary-options]');
      const summaryQuantity = root.querySelector('[data-xt-summary-quantity]');
      const summaryArtwork = root.querySelector('[data-xt-summary-artwork]');
      const summaryTotal = root.querySelector('[data-xt-summary-total]');
      let variants = [];
      try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (error) { variants = []; }

      const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' }).format((Number(cents) || 0) / 100);
      const quantityInput = () => form.querySelector('input[name="quantity"]');
      const variantInput = () => form.querySelector('select[name="id"], input[name="id"]');

      const update = () => {
        const variantField = variantInput();
        const selectedId = variantField ? String(variantField.value) : '';
        const variant = variants.find((item) => String(item.id) === selectedId) || variants[0];
        const quantity = Math.max(1, Number(quantityInput()?.value || 1));
        const optionSelectors = Array.from(form.querySelectorAll('.single-option-selector'));
        const optionText = optionSelectors.map((select) => select.options[select.selectedIndex]?.text).filter(Boolean).join(' / ');
        if (summaryMethod) summaryMethod.textContent = method?.value || '';
        if (summaryOptions) summaryOptions.textContent = optionText || variant?.title || '';
        if (summaryQuantity) summaryQuantity.textContent = String(quantity);
        if (summaryArtwork) summaryArtwork.textContent = artwork?.files?.[0]?.name || root.dataset.notUploaded || '';
        if (summaryTotal) summaryTotal.textContent = money((variant?.price || 0) * quantity);
      };

      const validateArtwork = () => {
        if (!artwork || !fileError) return true;
        const file = artwork.files?.[0];
        fileError.hidden = true;
        fileError.textContent = '';
        if (!file) return false;
        const allowed = /\.(png|jpe?g|pdf|svg|eps|ai)$/i;
        if (!allowed.test(file.name)) {
          fileError.textContent = root.dataset.invalidType || '';
          fileError.hidden = false;
          artwork.value = '';
          update();
          return false;
        }
        if (file.size > 20 * 1024 * 1024) {
          fileError.textContent = root.dataset.invalidSize || '';
          fileError.hidden = false;
          artwork.value = '';
          update();
          return false;
        }
        return true;
      };

      form.addEventListener('change', () => window.setTimeout(update, 0));
      form.addEventListener('input', update);
      artwork?.addEventListener('change', validateArtwork);
      form.addEventListener('submit', (event) => {
        if (!validateArtwork()) {
          event.preventDefault();
          artwork?.focus();
          if (fileError && fileError.textContent === '') {
            fileError.textContent = root.dataset.requiredArtwork || '';
            fileError.hidden = false;
          }
        }
      }, true);
      update();
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-xt-order-builder]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
